import React from 'react'; // Required for React <17

interface LeaveInfoProps {
  totalLeaves: number;
  appliedLeaves: number;
  remainingLeaves: number;
  isLeaveExceeded: number;
  totalPaidLeave: number;
  totalUnpaidLeave: number;
}

export const LeaveInfoContainer = ({
  totalLeaves,
  appliedLeaves,
  remainingLeaves,
  isLeaveExceeded,
  totalPaidLeave,
  totalUnpaidLeave
}: LeaveInfoProps) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '90%',
        gap: '10px',
        margin: '0 auto',
        paddingTop: '10px'
      }}
    >
      <div
        style={{
          backgroundColor: '#d1ecf1',
          padding: '10px',
          borderRadius: '5px',
          flex: 1,
          textAlign: 'center'
        }}
      >
        Annual Leave: {totalLeaves}
      </div>
      <div
        style={{
          backgroundColor: '#fff3cd',
          padding: '10px',
          borderRadius: '5px',
          flex: 1,
          textAlign: 'center'
        }}
      >
        Applied Leave: {appliedLeaves}
      </div>
      <div
        style={{
          backgroundColor: '#c3e6cb',
          padding: '10px',
          borderRadius: '5px',
          flex: 1,
          textAlign: 'center'
        }}
      >
        Remaining Leave: {remainingLeaves}
      </div>
      {/* <div
        style={{
          backgroundColor: '#FF0000',
          color: '#fff', // Make text visible on red background
          padding: '10px',
          borderRadius: '5px',
          flex: 1,
          textAlign: 'center'
        }}
      >
        Exceed Leave: {isLeaveExceeded}
      </div> */}
      <div
        style={{
          backgroundColor: '#c3e6cb',
          padding: '10px',
          borderRadius: '5px',
          flex: 1,
          textAlign: 'center'
        }}
      >
        Paid Leave: {totalPaidLeave}
      </div>
      <div
        style={{
          backgroundColor: '#FF0000',
          padding: '10px',
          borderRadius: '5px',
          flex: 1,
          textAlign: 'center'
        }}
      >
        Unpaid Leave: {totalUnpaidLeave}
      </div>
    </div>
  );
};
